import { Spin } from 'antd'
import Flex from 'components/Flex'
import Page from 'modules/Page/Container/index'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom'
import { authenticated } from 'routes/config/user'
import styled from 'styled-components'

const { AUTH_URL } = process.env

const PageFlex = styled(Flex)`
  overflow: hidden;
`
const AuthPage = ({ isAuthenticated, getStudentData, SignIn }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const lastLocation = useSelector(state => state?.auth?.lastLocation)
  const studentId = useSelector(state => state?.auth?.studentId)
  const [searchParams] = useSearchParams()
  const pathname = window.location.pathname
  const [isLoading, setIsLoading] = useState(true)
  const [studentDetails, setStudentDetails] = useState({})
  const [error, setError] = useState(null)

  const fetchStudentData = async id => {
    let response = await getStudentData(id || studentId)
    setStudentDetails(response)
  }

  const signInUser = async () => {
    const token = searchParams.get('token')

    if (!token && !isAuthenticated) {
      window.open(AUTH_URL, '_self')
    }

    const studentId = await SignIn(token)
    fetchStudentData(studentId)
  }

  useEffect(() => {
    signInUser()
  }, [])

  useEffect(() => {
    if (isAuthenticated) {
      // Only redirect to /assessment if user is on root path or login-related paths
      // Don't redirect if they're accessing a specific assessment URL
      const currentPath = location.pathname
      const isRootPath = currentPath === '/' || currentPath === ''
      const isLoginPath = currentPath.includes('login') || currentPath.includes('auth')
      const isDirectAssessmentPath = currentPath.includes('/assessment/direct/')

      if ((isRootPath || isLoginPath) && !isDirectAssessmentPath) {
        navigate('/assessment')
      }
      setIsLoading(false)
    }
  }, [isAuthenticated, location.pathname])

  return (
    <PageFlex>
      {isAuthenticated && !isLoading  && (
        <Page
          isOnboarding={false}
          questionnaire={false}
        >
          <Routes>
            {authenticated.map(({ routePath, Component }) => {
              return (
                <Route
                  key={routePath}
                  path={routePath}
                  element={<Component />}
                ></Route>
              )
            })}
          </Routes>
        </Page>
      )}

      {isLoading && <Spin />}
    </PageFlex>
  )
}

export default AuthPage
